module.exports = __webpack_public_path__ + "static/media/Monedero-Gasolina.3f660594.png";